import { formatDateIgnoreOffset } from "../../utils/dateUtils";

export const getDeviceInventory = (state, deviceId) => {
  const filtered = state.deviceInventory.filter(
    (inv) => inv.deviceId === deviceId
  );
  if (filtered.length > 0) return filtered[0].inventory;

  return [];
};

export const getUnidentifiedTags = (state, deviceId) => {
  const filtered = state.deviceInventory.filter(
    (inv) => inv.deviceId === deviceId
  );
  if (filtered.length > 0) return filtered[0].undientifiedTags;

  return [];
};

export const getLastScanTime = (state, deviceId) => {
  const filtered = state.deviceInventory.filter(
    (inv) => inv.deviceId === deviceId
  );
  if (filtered.length > 0 && filtered[0].inventory.length > 2)
    return formatDateIgnoreOffset(filtered[0].inventory[2].inventoryTime);

  return "";
};

export const getProductTotals = (state, deviceId) => {
  let productTotals = {
    totalItems: 0,
    productCounts: [],
  };

  const filtered = state.deviceInventory.filter(
    (inv) => inv.deviceId === deviceId
  );

  if (filtered.length > 0) {
    productTotals.totalItems = filtered[0].totalItems;
    productTotals.productCounts = filtered[0].productCounts;
  }

  return productTotals;
};
